import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, exhaustMap, switchMap } from 'rxjs/operators';
import { ReviewActions } from '../../review-store';
import { ReviewService } from '../services/review.service';
import { AnalysisData } from '@sleipai/sleip-models';
import { cloneDeep } from 'lodash';

@Injectable()
export class ReviewEffects {
  loadReviews$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReviewActions.loadReviews),
      exhaustMap(() => {
        return this.reviewService.getAllPendingReviews().pipe(
          map((data: AnalysisData[]) => {
            return ReviewActions.addReviews({ reviews: data });
          })
        );
      })
      // concatMap(() =>
      //   /** An EMPTY observable only emits completion. Replace with your own observable API request */
      //   EMPTY.pipe(
      //     map((data) => ReviewActions.loadReviewsSuccess({ data })),
      //     catchError((error) => of(ReviewActions.loadReviewsFailure({ error })))
      //   )
      // )
    );
  });

  loadSingleReview$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReviewActions.loadSingleReview),
      exhaustMap(({ reviewId }) => {
        return this.reviewService.getSingleReview(reviewId).pipe(
          switchMap((review: AnalysisData) => {
            const reviewData = cloneDeep(review);
            delete reviewData.listOfStrides;
            return [
              ReviewActions.addStrideList({ strideList: review.listOfStrides }),
              ReviewActions.addSingleReview({ review: reviewData }),
            ];
          })
        );
      })
    );
  });

  constructor(private actions$: Actions, private reviewService: ReviewService) {}
}
